<template>
  <div>
    <h5 class="vue-title">{{ $t("SERVICECATEGORYMASTERCREATE") }} {{ $t(this.FormTitle) }}</h5>
    <div class="row">
      <div class="col-12">
        <b-form class="formTextSize" @submit.prevent="submit">
          <b-row>
            <b-col md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>{{ $t("SELECTPARENT") }}</span>
                <b-form-select
                  v-model.trim="$v.service.parent_id.$model"
                  :options="partnerList"
                  value-field="id"
                  text-field="name"
                ></b-form-select>
                サブサービスを追加するには親を選択する必要があります


              </b-form-group>
              
            </b-col>
            <b-col md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("SERVICENAME") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  v-model.trim="$v.service.name.$model"
                  class="inputField"
                  type="text"
                  id="name"
                  autocomplete="name"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors :control="$v.service.name" :field="$t('MANDATORY')" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("DESCRIPTION") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-textarea
                  id="textarea"
                  v-model.trim="$v.service.description.$model"
                  rows="2"
                ></b-form-textarea>
                <show-errors :control="$v.service.description" :field="$t('MANDATORY')" />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-row>
                <b-col :md="url == null ? '12' : '9'">
                  <b-form-group id="addressField" label-for="input-1">
                    <span>
                      {{ $t("ICON") }}
                      <span class="mandotry-color">*</span>
                    </span>
                    <b-form-file
                      :placeholder="$t('SELECTICON2')"
                      v-model.trim="$v.service.icon.$model"
                      @change="onFileChange"
                      browse-text="参照"
                      accept="image/svg+xml"
                      ref="myFile"
                      id="imageUpload"
                    ></b-form-file>
                    <show-errors :control="$v.service.icon" :field="$t('MANDATORY')" />
                  </b-form-group>
                  <p class="format-error">ファイル形式が svgファイルのみ有効（最大ファイルサイズは512KB）</p>
                </b-col>
                <b-col md="3" v-if="url != null">
                  <div class="add-service">
                    <img :v-if="url" :src="url" alt="icon" width="49px" />
                    <span @click="clearImage" aria-hidden="true" class="imageClose">×</span>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12" class="text-center">
              <b-button
                class="btn btn-secondary formTextSizeBlack mr-2 paddingMediaQry"
                to="/service"
              >{{ $t("CANCEL") }}</b-button>
              <b-button
                class="formTextSizeBlack paddingMediaQry"
                variant="primary"
               type="submit"
              >{{ $t("ADDTO") }}</b-button>
            </b-col>
          </b-row>
          <b-row></b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  SERVICE_LIST,
  CREATE_SERVICE_CATEGORY_MASTER,
  GET_SERVICE_CATEGORY_MASTER,
  UPDATE_SERVICE_CATEGORY_MASTER,
  ALLCATEGRY_PARTNER
} from "@/store/actions.type";
import * as _ from "lodash";
import ShowErrors from "@/components/ShowErrors";
import { required } from "vuelidate/lib/validators";
import * as get from "lodash";
import { CONSTANTS } from "@/shared/utils";

export default {
  name: "addService",
  components: {  ShowErrors },
  data: function() {
    return {
      CONSTANTS: null,
      FormTitle: "",
      selected: null,
      service: {
        parent_id: null,
        name: "",
        description: "",
        icon: null
      },
      parentOptions: [],
      partnerList: [],
      isLoading: "",
      url: null,
      imageSize: 0
    };
  },
  validations: {
    service: {
      parent_id: {},
      name: { required },
      description: { required },
      icon: { required }
    }
  },
  computed: {
    ...mapGetters(["serviceList", "serviceCategoryMaster"])
  },
  methods: {
    redirect() {
      this.$router.push({
        name: "service"
      });
    },
    createFrom(form) {
      console.log(form);
    },
    onFileChange(e) {
      const file = e.target.files[0];
      var fileName = document.getElementById("imageUpload").value;
      var idxDot = fileName.lastIndexOf(".") + 1;
      var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
      if (
        (
          extFile != "svg"
        )
      ) {
        this.$toast.error({
          message: "形式がsvgファイルのみ有効"
        });
        document.getElementById("imageUpload").value = "";

        console.log("this.service", this.service)
        this.url = null;
        return
      }

      this.imageSize = Math.round(file.size / 1000);
      if (this.imageSize > CONSTANTS.imageSizeMax) {
        this.$toast.error({
          message: this.$t("UPLOADLIMITERROR")
        });
        this.url = null;
         document.getElementById("imageUpload").value = "";

      } else {
        this.url = URL.createObjectURL(file);
      }
    },
    clearImage() {
      this.url = null;
      this.service.icon = null;
    },
    submit(evt) {
      this.$toast.removeAll();
      this.$v.$touch();
      if (this.imageSize > CONSTANTS.imageSizeMax) {
        this.$toast.error({
          message: this.$t("UPLOADLIMITERROR")
        });
        return;
      }

      if (!this.$v.service.$invalid) {
        this.isLoading = this.$loading.show({
          loader: "dots",
          color: "#007bff"
        });
        let formData = new FormData();
        formData.append("icon", this.service.icon);
        formData.append("parent_id", this.service.parent_id);
        formData.append("description", this.service.description);
        formData.append("name", this.service.name);
        if (_.get(this.params, "id", 0)) {
          formData.append("id", this.params.id);
          this.$store
            .dispatch(UPDATE_SERVICE_CATEGORY_MASTER, {
              formData: formData,
              id: this.params.id
            })
            .then(data => {
              this.isLoading.hide();
              if (data.status) {
                this.$toast.success({
                  message: data.message
                });
                this.$router.push({
                  name: "service"
                });
              } else {
                this.$toast.error({
                  message: data.message
                });
              }
            });
        } else {
          /*
                Add the form data we need to submit
            */

          this.$store
            .dispatch(CREATE_SERVICE_CATEGORY_MASTER, formData)
            .then(data => {
              this.isLoading.hide();
              if (data.status) {
                this.$toast.success({
                  message: data.message
                });
                this.$router.push({
                  name: "service"
                });
              } else {
                this.$toast.error({
                  message: data.message
                });
              }
            });
        }
      }
    }
  },
  created() {
    this.CONSTANTS = CONSTANTS;

    this.$toast.removeAll();
    this.$store
      .dispatch(ALLCATEGRY_PARTNER, { field: "id", sort: "desc" })
      .then(data => {
        if (data.status) {
          this.partnerList.push({ id: null, name: "選択してください" });
          this.partnerList = _.concat(
            this.partnerList,
            _.get(data, "categories", [])
          );
        }
      });
    this.parentOptions = _.uniqBy(this.serviceCategoryMaster.list, "parent_id");
    this.parentOptions = get.filter(
      this.parentOptions,
      item => item.parent_id != 0
    );
    this.FormTitle = "CREATE";
    console.log("this.parentOptions", this.parentOptions);
    this.$store.dispatch(SERVICE_LIST);

    this.params = this.$route.params;
    if (_.get(this.params, "id", 0)) {
      this.FormTitle = "EDIT";
      this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });

      this.$store
        .dispatch(GET_SERVICE_CATEGORY_MASTER, {
          id: _.get(this.params, "id", 0)
        })
        .then(data => {
          this.isLoading.hide();
          if (_.get(data, "status", 0)) {
            this.service = {
              parent_id: _.get(data, "category.parent_id", ""),
              name: _.get(data, "category.name", ""),
              description: _.get(data, "category.description", ""),
              icon: _.get(data, "category.icon", null)
            };
            this.url = _.get(data, "category.icon", "");
          }
        });
    }
  }
};
</script>
<style scoped>
.imageClose {
  margin-left: 16px;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  cursor: pointer;
}
@media (min-width: 770px) {
  .paddingMediaQry {
    margin-top: 28px;
  }
  .textCenterMedia {
    float: "right";
  }
}
.format-error{
  position: absolute;
    font-size: 10px;
}
.add-service{
  margin-top: 20px;
}
</style>
